import React, { useCallback } from 'react'
import { DevPanelData } from '../types'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import RadioInput from 'LuxKit/Radio/RadioInput'
import { usePseudoloc, type PseudolocMode } from 'i18n/PseudolocContext'

interface Props {
  state: DevPanelData
}

const RADIO_GROUP_NAME = 'pseudoloc-mode'

function I18nTab(_props: Props) {
  const { mode, setMode } = usePseudoloc()

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setMode(e.target.value as PseudolocMode)
  }, [setMode])

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">Internationalization</Heading>

      <VerticalSpacer gap={12}>
        <BodyText variant="medium" weight="bold">Pseudolocalization Mode</BodyText>
        <VerticalSpacer gap={8}>
          <RadioInput
            name={RADIO_GROUP_NAME}
            value="off"
            checked={mode === 'off'}
            onChange={handleChange}
          >
            Off
          </RadioInput>
          <RadioInput
            name={RADIO_GROUP_NAME}
            value="full"
            checked={mode === 'full'}
            onChange={handleChange}
          >
            Full Pseudo (accented + expanded)
          </RadioInput>
          <RadioInput
            name={RADIO_GROUP_NAME}
            value="length"
            checked={mode === 'length'}
            onChange={handleChange}
          >
            Length Pseudo (block padding)
          </RadioInput>
        </VerticalSpacer>
        <BodyText variant="small" colour="neutral-two">
          Toggle with <b>Cmd+Alt+Shift+P</b> to cycle: Off → Full → Length
        </BodyText>
      </VerticalSpacer>

      <MessageBanner kind="informational-primary">
        <BodyText variant="small">
          <b>Full Pseudo</b> adds brackets and replaces characters with accented versions.
          <b> Length Pseudo</b> adds █ block characters to simulate translation expansion while keeping text readable.
        </BodyText>
        <ul style={{ marginTop: '8px', marginBottom: 0, paddingLeft: '20px' }}>
          <li>Untranslated strings (they won't have brackets/blocks)</li>
          <li>UI layout issues with longer text</li>
          <li>Hardcoded strings that bypass i18n</li>
        </ul>
      </MessageBanner>
    </VerticalSpacer>
  </Pane>
}

export default I18nTab
